import { oz } from '@weft/utils';
import { CommitmentTierUsageDataSchema } from '../../../../primitives';

export const CommitmentTiersUsageMapSchema = oz.record(
  oz.string(),
  oz.array(CommitmentTierUsageDataSchema).nonempty(),
).openapi('CommitmentTiersUsageMap');

export type CommitmentTiersUsageMap = oz.infer<typeof CommitmentTiersUsageMapSchema>;